import { APP_VERSION } from '../lib/spaceIdentity';

// Settings ▸ About — the honest home for the version string that used to sit as
// dev chrome in the app header (T-0200). A build detail belongs where someone
// goes looking for it, not painted across the messaging surface.

export function AboutSection() {
  return (
    <div className="settings-section about-section">
      <h3>About</h3>
      <dl className="about-facts">
        <dt>Product</dt>
        <dd>Tizok</dd>
        <dt>Version</dt>
        <dd>v{APP_VERSION}</dd>
      </dl>
    </div>
  );
}
